/**
 * M2 onboarding: Brand section — Logo picker + Brand color.
 */

import React, { useState, useEffect } from 'react';
import { FormColorSelector } from '../../../components/ui/form-color-selector';
import LogoPicker from './LogoPicker';

const DEFAULT_BRAND_COLOR = '#69995E';
const MAX_LOGO_IMAGES = 6;

export default function OrgBrandSection({
  payload,
  logoUrl,
  onLogoUrlChange,
  userUploadedLogoUrl,
  ogImage,
  onUploadClick,
  suggestedBrandColor,
  brandColor,
  onBrandColorChange,
}) {
  const [selectedLogoUrl, setSelectedLogoUrl] = useState(logoUrl);

  useEffect(() => {
    setSelectedLogoUrl(logoUrl);
  }, [logoUrl]);

  const handleSelectLogo = (url) => {
    setSelectedLogoUrl(url);
    onLogoUrlChange?.(url);
  };

  const imageOptions = [
    ogImage && { key: 'website', url: ogImage, alt: 'From website', title: 'From your website — click to use this logo' },
    payload?.logoUrl && { key: 'ein', url: payload.logoUrl, alt: 'From EIN', title: 'From EIN lookup — click to use this logo' },
    userUploadedLogoUrl && { key: 'upload', url: userUploadedLogoUrl, alt: 'Your upload', title: 'Your uploaded logo — click to use' },
  ].filter(Boolean).slice(0, MAX_LOGO_IMAGES);

  // Auto-select the first available logo if nothing is selected yet
  useEffect(() => {
    if (!selectedLogoUrl && imageOptions.length > 0) {
      handleSelectLogo(imageOptions[0].url);
    }
  }, [imageOptions.length]); // eslint-disable-line react-hooks/exhaustive-deps

  const effectiveBrandColor = (brandColor || suggestedBrandColor || DEFAULT_BRAND_COLOR).startsWith('#') && (brandColor || suggestedBrandColor || DEFAULT_BRAND_COLOR).length >= 7
    ? (brandColor || suggestedBrandColor || DEFAULT_BRAND_COLOR).slice(0, 7)
    : DEFAULT_BRAND_COLOR;

  const showLogo = onLogoUrlChange || onUploadClick || ogImage || payload?.logoUrl || userUploadedLogoUrl;
  const showColor = onBrandColorChange;

  if (!showLogo && !showColor) return null;

  return (
    <div className="space-y-6">
      {showLogo && (
        <LogoPicker
          imageOptions={imageOptions}
          selectedUrl={selectedLogoUrl}
          onSelect={handleSelectLogo}
          onUploadClick={onUploadClick}
          uploadButtonLabel={userUploadedLogoUrl ? 'Upload another' : 'Upload my own'}
        />
      )}

      {showColor && (
        <div className="space-y-1.5">
          <label className="text-base font-medium text-ink-secondary">Brand color</label>
          <FormColorSelector
            value={effectiveBrandColor}
            onChange={onBrandColorChange}
            defaultColor={DEFAULT_BRAND_COLOR}
            className="h-7"
          />
        </div>
      )}
    </div>
  );
}
